var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{style:({width:'100vw',height:'100vh'})},[_c('a-layout-sider',{style:({ background:'white !important',})},[_c('Sider')],1),_c('a-layout',[_c('a-layout-header',{staticClass:"a-heder",style:({ background:'white !important'})},[_c('Header')],1),_c('a-layout-content',[_c('router-view',{key:_vm.$route.path})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }